import React from 'react';
import { cn } from '../../design-system/cn';

const TAB_ACTIVE = {
  brand: 'bg-emerald-500 text-black',
  warning: 'bg-amber-500 text-black',
  admin: 'bg-violet-500 text-black',
};

export function TabList({ className, children }) {
  return (
    <div
      className={cn(
        'flex flex-wrap gap-2 p-1 rounded-xl bg-white/5 border border-white/10',
        className
      )}
      role="tablist"
    >
      {children}
    </div>
  );
}

export function Tab({ active, accent = 'brand', className, children, ...props }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      className={cn(
        'flex-1 min-w-[4.5rem] py-3 rounded-lg text-sm font-black uppercase tracking-wider transition-all',
        active ? TAB_ACTIVE[accent] || TAB_ACTIVE.brand : 'text-gray-400 hover:text-white',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
